import styles from '../Account.module.css';
import AccountCard from '../AccountCard';
import SectionHead from '../SectionHead';
import StatusBadge from '../StatusBadge';
import EmptyState from '../EmptyState';
import Icon from '../Icon';
import { formatMoney, formatDate } from '../../../services/billingService';

// Invoices come from Stripe and link to Stripe. The previous version BUILT a .txt file in
// the browser from the fields it happened to have and called it an invoice; it carried no
// tax breakdown, no invoice number Stripe would recognise and no legal entity details, so it
// was not something anyone could file. Stripe already hosts both an HTML receipt and a
// proper PDF, so we link to those instead of inventing a document.

export default function InvoicesSection({ billing }) {
  const invoices = billing?.invoices || [];

  return (
    <>
      <SectionHead title="Invoices" subtitle="Your billing history. Download any invoice for your records." />

      <AccountCard title="Invoice history" description="Every charge on your account, with a downloadable copy.">
        {invoices.length === 0 ? (
          <EmptyState
            icon={<Icon name="fileText" size={20} />}
            title={billing?.loaded && billing?.billingAvailable === false
              ? 'Invoices are unavailable right now.'
              : 'No invoices yet'}
            description={billing?.loaded && billing?.billingAvailable === false
              ? 'We could not reach Stripe to read your billing history. Try again in a moment.'
              : 'Invoices appear here after your first payment, with a PDF you can file.'}
          />
        ) : (
          <div className={styles.tableWrap}>
            <table className={styles.table}>
              <thead>
                <tr>
                  <th>Invoice number</th>
                  <th>Invoice date</th>
                  <th className={styles.thRight}>Amount</th>
                  <th>Status</th>
                  <th className={styles.thRight}>Download</th>
                </tr>
              </thead>
              <tbody>
                {invoices.map((inv) => (
                  <tr key={inv.id}>
                    <td className={styles.invId}>{inv.id}</td>
                    <td>{formatDate(inv.date)}</td>
                    <td className={styles.tdRight}>{formatMoney(inv.amount)}</td>
                    <td><StatusBadge status={inv.status} /></td>
                    <td className={styles.tdRight}>
                      {inv.pdfUrl || inv.hostedUrl ? (
                        <a
                          className={styles.dlBtn}
                          href={inv.pdfUrl || inv.hostedUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <Icon name="fileText" size={13} /> {inv.pdfUrl ? 'PDF' : 'View'}
                        </a>
                      ) : (
                        <span className={styles.note}>-</span>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </AccountCard>
    </>
  );
}
